const FORM_SUBMITTED = 'calculator-form-submitted';

export default {
	FORM_SUBMITTED,
};
